import React, { PropsWithChildren } from 'react'
import {
  OverlayArrow,
  TooltipTrigger,
  Tooltip as AriaTooltip,
  TooltipProps,
  Button,
} from 'react-aria-components'

import './Tooltip.css'

type Props = {
  text: string
} & PropsWithChildren &
  TooltipProps

export function Tooltip({ text, children, ...props }: Props) {
  return (
    <TooltipTrigger>
      <Button className="Tooltip-Button">{children}</Button>
      <AriaTooltip {...props}>
        <OverlayArrow>
          <svg width={8} height={8} viewBox="0 0 8 8">
            <path d="M0 0 L4 4 L8 0" />
          </svg>
        </OverlayArrow>

        {text}
      </AriaTooltip>
    </TooltipTrigger>
  )
}
